<template>
  <div>
    <v-card-text v-if="services.length === 0" class="pb-0 pt-0 pl-0">
      {{
        $t(
          "components.miscellaneous.partnerService.thereAreNoServicesAvailableAtTheMoment"
        )
      }}
    </v-card-text>

    <v-list flat subheader three-line v-if="services.length !== 0" class="mt-2">
      <template>
        <v-list-item v-for="(service, index) in services" :key="index">
          <template>
            <v-list-item-action>
              <v-checkbox
                color="primary"
                v-model="service.enabled"
                :disabled="service.is_read_only"
                @change="handleService"
              ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ service.name }}</v-list-item-title>
              <div class="text--secondary" v-if="service.short_text !== null">
                {{ service.short_text }}
              </div>
              <div class="text--secondary mt-2" v-if="service.learnMore">
                {{ service.text }}
              </div>

              <v-list-item-subtitle>
                <v-btn
                  x-small
                  class="pl-0 ml-0 pr-0"
                  color="secondary"
                  text
                  @click="handleLearnMore(service)"
                  v-if="!(service.text === null || service.text.length === 0)"
                >
                  {{
                    !service.learnMore
                      ? $t("components.miscellaneous.partnerService.showMore")
                      : $t("components.miscellaneous.partnerService.showLess")
                  }}
                </v-btn>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    services: {
      type: Array,
      default: Array,
    },
    readOnly: {
      type: String,
      default: String,
    },
    consents: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedServices: [],
  }),

  computed: {
    canUserEdit() {
      if (this.consents) {
        return true;
      }

      return this.readOnly === "WRITE";
    },
  },
  methods: {
    handleService() {
      this.$emit("update:services", this.services);
    },
    handleLearnMore(service) {
      service.learnMore = !service.learnMore;
      // this.learnMore = !this.learnMore;
    },
  },
};
</script>

<style>
.sensor-pill {
  border-right: 6px solid transparent;
  cursor: pointer;
}
</style>
